/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type PairDevicesCustomersPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PairDevicesCustomersPageQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: string, customers: Array<{ __typename: 'Customer', id: string, name: string }> } };

export type EnrolmentsForOrganizationQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int'];
  pageNumber: Types.Scalars['Int'];
}>;


export type EnrolmentsForOrganizationQuery = { __typename: 'Query', enrolmentsForOrganization: { __typename: 'QueryEnrolmentsForOrganizationPayload', totalCount: number, zteEnrolment: Array<{ __typename: 'ZteEnrolment', id: string, status: string, customerId?: string | null }> } };

export type BulkPairZteEnrolmentToCustomerMutationVariables = Types.Exact<{
  input: Types.ZteBulkEnrolmentPairInput;
}>;


export type BulkPairZteEnrolmentToCustomerMutation = { __typename: 'Mutation', bulkPairZteEnrolmentToCustomer: { __typename: 'ZteBulkEnrolmentPairPayload', enrolments: Array<{ __typename: 'ZteEnrolment', id: string }> } };


export const PairDevicesCustomersPageDocument = gql`
    query PairDevicesCustomersPage {
  organization {
    id
    customers {
      id
      name
    }
  }
}
    `;

/**
 * __usePairDevicesCustomersPageQuery__
 *
 * To run a query within a React component, call `usePairDevicesCustomersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePairDevicesCustomersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePairDevicesCustomersPageQuery({
 *   variables: {
 *   },
 * });
 */
export function usePairDevicesCustomersPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PairDevicesCustomersPageQuery, PairDevicesCustomersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PairDevicesCustomersPageQuery, PairDevicesCustomersPageQueryVariables>(PairDevicesCustomersPageDocument, options);
      }
export function usePairDevicesCustomersPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PairDevicesCustomersPageQuery, PairDevicesCustomersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PairDevicesCustomersPageQuery, PairDevicesCustomersPageQueryVariables>(PairDevicesCustomersPageDocument, options);
        }
export type PairDevicesCustomersPageQueryHookResult = ReturnType<typeof usePairDevicesCustomersPageQuery>;
export type PairDevicesCustomersPageLazyQueryHookResult = ReturnType<typeof usePairDevicesCustomersPageLazyQuery>;
export type PairDevicesCustomersPageQueryResult = ApolloReactCommon.QueryResult<PairDevicesCustomersPageQuery, PairDevicesCustomersPageQueryVariables>;
export const EnrolmentsForOrganizationDocument = gql`
    query EnrolmentsForOrganization($pageSize: Int!, $pageNumber: Int!) {
  enrolmentsForOrganization(pageSize: $pageSize, pageNumber: $pageNumber) {
    totalCount
    zteEnrolment {
      id
      status
      customerId
    }
  }
}
    `;

/**
 * __useEnrolmentsForOrganizationQuery__
 *
 * To run a query within a React component, call `useEnrolmentsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrolmentsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrolmentsForOrganizationQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useEnrolmentsForOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EnrolmentsForOrganizationQuery, EnrolmentsForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EnrolmentsForOrganizationQuery, EnrolmentsForOrganizationQueryVariables>(EnrolmentsForOrganizationDocument, options);
      }
export function useEnrolmentsForOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnrolmentsForOrganizationQuery, EnrolmentsForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EnrolmentsForOrganizationQuery, EnrolmentsForOrganizationQueryVariables>(EnrolmentsForOrganizationDocument, options);
        }
export type EnrolmentsForOrganizationQueryHookResult = ReturnType<typeof useEnrolmentsForOrganizationQuery>;
export type EnrolmentsForOrganizationLazyQueryHookResult = ReturnType<typeof useEnrolmentsForOrganizationLazyQuery>;
export type EnrolmentsForOrganizationQueryResult = ApolloReactCommon.QueryResult<EnrolmentsForOrganizationQuery, EnrolmentsForOrganizationQueryVariables>;
export const BulkPairZteEnrolmentToCustomerDocument = gql`
    mutation bulkPairZteEnrolmentToCustomer($input: ZteBulkEnrolmentPairInput!) {
  bulkPairZteEnrolmentToCustomer(input: $input) {
    enrolments {
      id
    }
  }
}
    `;
export type BulkPairZteEnrolmentToCustomerMutationFn = ApolloReactCommon.MutationFunction<BulkPairZteEnrolmentToCustomerMutation, BulkPairZteEnrolmentToCustomerMutationVariables>;

/**
 * __useBulkPairZteEnrolmentToCustomerMutation__
 *
 * To run a mutation, you first call `useBulkPairZteEnrolmentToCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPairZteEnrolmentToCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPairZteEnrolmentToCustomerMutation, { data, loading, error }] = useBulkPairZteEnrolmentToCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkPairZteEnrolmentToCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkPairZteEnrolmentToCustomerMutation, BulkPairZteEnrolmentToCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkPairZteEnrolmentToCustomerMutation, BulkPairZteEnrolmentToCustomerMutationVariables>(BulkPairZteEnrolmentToCustomerDocument, options);
      }
export type BulkPairZteEnrolmentToCustomerMutationHookResult = ReturnType<typeof useBulkPairZteEnrolmentToCustomerMutation>;
export type BulkPairZteEnrolmentToCustomerMutationResult = ApolloReactCommon.MutationResult<BulkPairZteEnrolmentToCustomerMutation>;
export type BulkPairZteEnrolmentToCustomerMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkPairZteEnrolmentToCustomerMutation, BulkPairZteEnrolmentToCustomerMutationVariables>;